var _excluded = ["placeholder", "label", "className", "errorMessage", "help", "onBlur", "onChange", "onError", "onFocus", "type", "tag", "inputRef", "mask", "id", "hasValue", "hasError", "hasClear", "iconName", "hasCharactersCounter", "charactersCounterHelp", "maxCharacters"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { Input, InputContainer, StyledError, Label, HelpMsg, IconContainer, LimitCharactersContainer } from './StyledInput';
import { Iclose, Iverify2 } from '../AgroIcon/icons';
import { Text } from '../Text';
var icons = {
  verify2: Iverify2
};
var BasicInput = withCssProps(function (_ref) {
  var _props$value;
  var _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    label = _ref.label,
    className = _ref.className,
    errorMessage = _ref.errorMessage,
    help = _ref.help,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onError = _ref.onError,
    onFocus = _ref.onFocus,
    type = _ref.type,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'input' : _ref$tag,
    inputRef = _ref.inputRef,
    mask = _ref.mask,
    id = _ref.id,
    hasValue = _ref.hasValue,
    hasError = _ref.hasError,
    _ref$hasClear = _ref.hasClear,
    hasClear = _ref$hasClear === void 0 ? false : _ref$hasClear,
    iconName = _ref.iconName,
    _ref$hasCharactersCou = _ref.hasCharactersCounter,
    hasCharactersCounter = _ref$hasCharactersCou === void 0 ? false : _ref$hasCharactersCou,
    charactersCounterHelp = _ref.charactersCounterHelp,
    _ref$maxCharacters = _ref.maxCharacters,
    maxCharacters = _ref$maxCharacters === void 0 ? 255 : _ref$maxCharacters,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocus = _useState2[0],
    setIsFocus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    limitError = _useState4[0],
    setLimitError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var Icon = icons[iconName];
  var _useState7 = useState(((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) || 0),
    _useState8 = _slicedToArray(_useState7, 2),
    count = _useState8[0],
    setCount = _useState8[1];
  var handleChange = function handleChange(e) {
    if (mask) {
      e.currentTarget.value = mask(e.currentTarget.value);
    }
    setValue(e.currentTarget.value);
    setCount(e.currentTarget.value.length);
    setLimitError(e.currentTarget.value.length > maxCharacters);
    if (onChange) {
      onChange(e);
    }
  };
  var handleBlur = function handleBlur(event) {
    setIsFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleFocus = function handleFocus(event) {
    setIsFocus(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleError = function handleError() {
    if (onError) {
      onError();
    }
  };
  var clearInput = function clearInput() {
    setValue('');
    if (onChange) {
      onChange('');
    }
  };
  useEffect(function () {
    setValue(props.defaultValue || '');
  }, [props.defaultValue, props.value]);
  useEffect(function () {
    var _props$value2, _props$value3;
    setCount(((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.length) || 0);
    setLimitError(((_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.length) > maxCharacters);
  }, []);
  return /*#__PURE__*/React.createElement(InputContainer, {
    className: className
  }, label ? /*#__PURE__*/React.createElement(Label, {
    type: type,
    isFocus: isFocus,
    hasError: hasError || errorMessage && errorMessage.length || limitError,
    htmlFor: props.name,
    disabled: props.disabled,
    value: props.value || value || hasValue,
    hasPlaceholder: placeholder && placeholder.length
  }, label) : null, /*#__PURE__*/React.createElement(Input, _extends({
    as: tag,
    type: type,
    id: id,
    ref: inputRef,
    className: "".concat(errorMessage || hasError || limitError ? 'input__invalid' : ''),
    placeholder: placeholder,
    onBlur: function onBlur(e) {
      return handleBlur(e);
    },
    onError: hasError ? handleError() : null,
    onFocus: function onFocus(e) {
      return handleFocus(e);
    },
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }, props)), iconName && /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, null)), hasClear && /*#__PURE__*/React.createElement(IconContainer, {
    hasClear: hasClear
  }, /*#__PURE__*/React.createElement(Iclose, {
    height: "24px",
    width: "24px",
    fill: "gray800",
    onClick: function onClick() {
      return clearInput();
    }
  })), errorMessage && errorMessage.length && /*#__PURE__*/React.createElement(StyledError, null, errorMessage), help && help.length && /*#__PURE__*/React.createElement(HelpMsg, null, help), hasCharactersCounter && /*#__PURE__*/React.createElement(LimitCharactersContainer, null, /*#__PURE__*/React.createElement(Text, {
    type: "label-sm",
    color: props.disabled ? 'gray6' : maxCharacters - count < 0 ? 'red500' : 'gray8'
  }, charactersCounterHelp), /*#__PURE__*/React.createElement(Text, {
    type: "label-sm",
    color: props.disabled ? 'gray6' : maxCharacters - count < 0 ? 'red500' : 'gray8'
  }, maxCharacters - count)));
});
var BasicInputProptypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  help: PropTypes.string,
  onBlur: PropTypes.func,
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  tag: PropTypes.oneOf(['input', 'textarea']),
  inputRef: PropTypes.any,
  mask: PropTypes.func,
  hasValue: PropTypes.bool,
  hasError: PropTypes.bool,
  iconName: PropTypes.oneOf(['verify2'])
};
BasicInput.propTypes = BasicInputProptypes;
BasicInput.displayName = 'BasicInput';
export { BasicInput, BasicInputProptypes };